module.exports = __webpack_public_path__ + "assets/images/img/apple-app-store.2452bfd45d0ce848e544be7b1d27cc4b.svg";